import { render, staticRenderFns } from "./InvigilationReport.vue?vue&type=template&id=8c53d214&scoped=true"
import script from "./InvigilationReport.vue?vue&type=script&lang=js"
export * from "./InvigilationReport.vue?vue&type=script&lang=js"
import style0 from "./InvigilationReport.scss?vue&type=style&index=0&id=8c53d214&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c53d214",
  null
  
)

export default component.exports